import DataBaseReportsRoutes from './DataBaseReportsRoutes';

export default DataBaseReportsRoutes;
